import { useState, useEffect, useCallback } from "react";
import logTrailService from "../services/logTrailService";

const formatLogs = (logs) => {
    const result11 = logs.reduce((acc, log) => {
        const date = new Date(log.createdAt);

        if (log.action === "SAVE_ALL") {
            if (!acc.save_all || date > new Date(acc.save_all)) {
                acc.save_all = log.createdAt;
            }
        }

        if (log.action === "FETCH_ALL") {
            if (!acc.fetch_all || date > new Date(acc.fetch_all)) {
                acc.fetch_all = log.createdAt;
            }
        }

        if (log.action === "SAVE_MULTIPLE") {
            if (!acc.save_multiple || date > new Date(acc.save_multiple)) {
                acc.save_multiple = log.createdAt;
            }
        }

        if (log.action === "FETCH_MANUAL" || log.action === "SAVE_MANUAL") {
            if (log.eventId && log.eventId !== "0") {
                const existing = acc.save_manual[log.eventId];

                if (!existing || date > new Date(existing)) {
                    acc.save_manual[log.eventId] = log.createdAt;
                }
            }
        }

        return acc;
    }, {
        save_all: null,
        save_multiple: null,
        fetch_all: null,
        save_manual: {}
    });
    return result11;
}

export const useLogTrail = ({ companyId, title }) => {
    const [logs, setLogs] = useState([]);

    const fetchLogs = useCallback(async () => {
        try {
            const response = await logTrailService.find(`companyId=${companyId}`);
            if (response.status === 200) {
                const rawLogs = Array.isArray(response?.data?.data) ? response.data.data : [];
                const scopedLogs = title
                    ? rawLogs.filter((log) => log?.title === title)
                    : rawLogs;
                const formattedLogs = formatLogs(scopedLogs);
                setLogs(formattedLogs);
            }
        } catch (err) {
            console.error("Failed to fetch logs:", err);
        }
    }, [companyId, title]);

     const saveLog = async ({eventId, action, title, companyId}) => {
        try {
            const payload = {
                action,
                eventId,
                title,
                companyId
            }
            const response = await logTrailService.create(payload);
            if (response.status === 200) {
                fetchLogs(); // Refresh the logs after saving
            }
        } catch (err) {
            console.error("Failed to fetch logs:", err);
        }
    };


    useEffect(() => {
        fetchLogs();
    }, [fetchLogs]);

    return { logs, fetchLogs, saveLog };
};

